export enum ProjectType {
  standAloneProject = 'StandAloneProject',
  standAloneProjectGroup = 'standAloneProjectGroup',
  project = 'Project',
  projectGroup = 'Project Group',
}
